import * as React from "react";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";
import { VendorCodesProps } from "components/flexComponents/WizardCarPWA/typings";
import { BrandDropdown } from "./BrandDropdown";
import { CouponCodeDropdown } from "./CouponCodeDropdown";
import { CouponCodeEntryFields } from "./CouponCodeEntryFields";
import { observer } from "mobx-react";
import { UitkExpandoLink, UitkExpandoLinkTypeSize } from "uitk-react-expando";
import { locKeys } from "../l10n";

export const VendorCodes = observer(({ carWizardState, mainColSpan, colSpan }: VendorCodesProps) => {
  const { formatText } = useLocalization();

  return (
    <div className="all-y-margin-two">
      <UitkExpandoLink
        type={UitkExpandoLinkTypeSize.TYPE_300}
        expandoTitle={formatText(carWizardState.config.iHaveDiscount)}
        isVisible={false}
      >
        <UitkLayoutGrid columns={mainColSpan} space="three" className="all-t-margin-two">
          <BrandDropdown label={formatText(locKeys.brandSelectionLabel)} lobState={carWizardState} colSpan={colSpan} />
          {!carWizardState.config.disableVendorCouponCode && (
            <CouponCodeDropdown
              label={formatText(locKeys.couponCodeSelectionLabel)}
              carWizardState={carWizardState}
              colSpan={colSpan}
            />
          )}
          <CouponCodeEntryFields
            carWizardState={carWizardState}
            vendor={carWizardState.preferredBrand}
            colSpan={colSpan}
          />
        </UitkLayoutGrid>
      </UitkExpandoLink>
    </div>
  );
});
